


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const viewReceiptReducer = function(state = initialState, action) {
switch (action.type) {
case Actions.VEIW_RECEIPT_OF_CUSTOMER:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.VEIW_RECEIPT_OF_CUSTOMER_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.VEIW_RECEIPT_OF_CUSTOMER_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
